<template>
    <div class="progress">
        <div class="progress-bar">
            <div class="progress-bar_outer" :style="{height: strokeWith + 'rem'}">
                <div class="progress-bar_inner" :style="{width: percentage + '%',background: '#fe2942'}">
                </div>
            </div>
            <div class="progress-bar_innerText" :style="{height: strokeWith + 'rem',lineHeight: strokeWith + 'rem'}"
                v-if="textInside && showText">{{ percentage }}%</div>
        </div>
        <div class="progress_text" :style="{fontSize: progressTextSize + 'px'}" v-if="!textInside && !showText">
            90%
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            strokeWith: {
                type: Number,
                default: 1
            },
            percentage: {
                type: Number,
                required: true,
                default: 0,
                validator: value => value >= 0 && value <= 100
            },
            status: {
                type: String
            },
            textInside: {
                type: Boolean,
                default: false
            },
            showText: {
                type: Boolean,
                defalut: true
            }
        },
        data() {
            return {

            }
        },
        computed: {
            progressTextSize() {
                return 12 + this.strokeWith * 0.1
            }
        },
    }
</script>

<style scoped>
    .progress {
        width: 98%;
    }

    .progress-bar {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .progress-bar_outer {
        width: 100%;
        background-color: #ffdade;
        border-radius: 1rem;
    }

    .progress-bar_inner {
        height: 100%;
        vertical-align: middle;
        border-radius: 1rem;
        background-color: aqua;
        transition: width 0.6s linear;
        text-align: right;
        color: #fff;
        font-size: 0.75rem;
    }

    .progress-bar_innerText {
        transform: scale(0.7);
    }

    .progress_text {
        display: inline-block;
        color: #606266;
        font-size: 0.75rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/progress.vue